
export const getCurrentTimeSecs = () => {
  return Math.floor(Date.now() / 1000);
}